var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{attrs:{"x-small":_vm.small,"color":_vm.CustomerStyle.TypeClass[_vm.type]}},[_vm._v(" "+_vm._s(_vm.type)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }